// extracted by mini-css-extract-plugin
export default {"breadcrumb":"zi-z","breadcrumbItem":"Ai-z","hideOnMobile":"Bi-z"};